import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ac792ede"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content" }
const _hoisted_2 = { class: "order-device" }
const _hoisted_3 = { class: "line-message" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "作业人员：", -1))
const _hoisted_5 = { class: "line-message" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "机台设备：", -1))
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" / ")
const _hoisted_8 = { class: "material-title" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "title-prefix" }),
  /*#__PURE__*/_createElementVNode("span", null, "备料接收物料")
], -1))
const _hoisted_10 = { class: "order-time" }
const _hoisted_11 = { class: "material-content" }
const _hoisted_12 = {
  key: 0,
  class: "item-style"
}
const _hoisted_13 = { class: "item-title-style" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "green" }, " [合格品] ", -1))
const _hoisted_15 = { style: {"font-weight":"500"} }
const _hoisted_16 = { class: "item-content-style" }
const _hoisted_17 = { class: "subItem-style_top" }
const _hoisted_18 = { class: "subItem-first-style" }
const _hoisted_19 = { class: "subItem-second-style" }
const _hoisted_20 = { class: "subItem-style_bottom" }
const _hoisted_21 = {
  key: 1,
  class: "item-style"
}
const _hoisted_22 = { class: "item-title-style" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "yellow" }, " [不良品] ", -1))
const _hoisted_24 = { style: {"font-weight":"500"} }
const _hoisted_25 = { class: "item-content-style" }
const _hoisted_26 = { class: "subItem-style_top" }
const _hoisted_27 = { class: "subItem-first-style" }
const _hoisted_28 = { class: "subItem-second-style" }
const _hoisted_29 = { class: "subItem-style_bottom" }
const _hoisted_30 = { class: "order-title" }
const _hoisted_31 = { class: "title" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title-prefix" }, null, -1))
const _hoisted_33 = { class: "order-code" }
const _hoisted_34 = { class: "order-info" }
const _hoisted_35 = { class: "order-content" }
const _hoisted_36 = { class: "order-message-style" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#666"} }, "生产信息：", -1))
const _hoisted_38 = {
  key: 0,
  style: {"color":"#222"}
}
const _hoisted_39 = {
  key: 1,
  style: {"color":"#222"}
}
const _hoisted_40 = { class: "order-message-style" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#666"} }, "作业人员：", -1))
const _hoisted_42 = /*#__PURE__*/_createTextVNode(" / ")
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"background-color":"#e5e5e5","height":"1px"} }, null, -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"94px"} }, null, -1))

import { onMounted, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { Toast } from 'vant'
import { getDB } from '@/apis/agencyAPI'
import { wTransferConfirm, acceptWTransfer } from '@/apis/WorkOrderAPI'

// interface dataModel{}


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute()
const router = useRouter()
let data: any = ref({})

// 获取详情
const getInfo = () => {
    wTransferConfirm({ id: route.query.id })
        .then(res => {
            if (res.code === 200) {
                data.value = res.data
            } else {
                Toast.fail({ message: res.message, forbidClick: false, duration: 2000 })
                setTimeout(() => {
                    router.go(-1)
                }, 2000)
            }
        })
        .catch(err => {
            console.log(err)
        })
}

const titleStr = (arr: [{sumBox: number, sumNum: number, unitName: string }]): string => {
  if (!arr) {
    return ''
  }
  let count = 0
  let all = 0
  for (const item of arr) {
    count = count + item.sumBox
    all = all + item.sumNum
  }
  return count + '盒 | ' + all + arr[0].unitName
}

const orderCount = (arr: [{}]): number => {
  if (!arr) {
    return 0
  }
  if (arr.length) {
    return arr.length
  }
  return 0
}

const submit = (): void => {
  acceptWTransfer({ id: route.query.id })
    .then(res => {
      if (res.code === 200) {
        Toast.success({  message: '备料成功', duration: 2000, forbidClick: true })
        setTimeout(() => {
          // router.back()
            if (route.query.status !== '1' || route.query.next == '1') {   // 备料接收确认后跳转转库单详情
                router.replace({ name: 'wTransferDetail', query: { id: route.query.id } })
                return
            }
            router.replace({ name: 'wInboundDetail', query: { id: route.query.id } })
        }, 2000)
      }
    })
    .catch(err => {
      console.log(err)
    })
}

// 获取待办详情(判断当前待办是否已处理)
const getDBs = async (id: string): Promise<any> => {
    let res = await getDB(id)
    if (res.code === 200) {
        if (res.data.status === 1 && route.query.status !== '1') {
            await router.replace({ name: 'wInboundDetail', query: { id: route.query.id } })
        } else {
            await getInfo()
        }
    }
}

onMounted(() => {
    if (route.query.dbid) {
        getDBs(route.query.dbid as string)
    } else {
        getInfo()
    }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("span", null, _toDisplayString(_unref(data).worker ? _unref(data).worker : '-') + " / " + _toDisplayString(_unref(data).groupName ? _unref(data).groupName : '-'), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).deviceList, (item, index) => {
          return (_openBlock(), _createElementBlock("span", { key: index }, [
            _createTextVNode(" [" + _toDisplayString(item.code) + "]" + _toDisplayString(item.name), 1),
            (index !== _unref(data).deviceList.length - 1)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _hoisted_7
                ], 64))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _hoisted_9,
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", null, "单号：" + _toDisplayString(_unref(data).transferNo), 1),
        _createElementVNode("div", null, "时间：" + _toDisplayString(_unref(data).validDate), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      (orderCount(_unref(data).qualifiedBeanList)!=0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _createElementVNode("span", _hoisted_15, _toDisplayString(titleStr(_unref(data).qualifiedBeanList)), 1)
            ]),
            _createElementVNode("div", _hoisted_16, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).qualifiedBeanList, (sub, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "subItem-style",
                  key: index
                }, [
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, _toDisplayString(sub.materialName + ' | ' + sub.materialCode), 1),
                    _createElementVNode("div", _hoisted_19, _toDisplayString(sub.sumBox + '盒 | ' + sub.sumNum + sub.unitName), 1)
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("span", null, _toDisplayString(sub.procedureName ? sub.procedureName : '-') + " | " + _toDisplayString(sub.batch ? sub.batch : '-'), 1)
                  ])
                ]))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true),
      (orderCount(_unref(data).rejectsBeanList)!=0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _hoisted_23,
              _createElementVNode("span", _hoisted_24, _toDisplayString(titleStr(_unref(data).rejectsBeanList)), 1)
            ]),
            _createElementVNode("div", _hoisted_25, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).rejectsBeanList, (sub, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "subItem-style",
                  key: index
                }, [
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("div", _hoisted_27, _toDisplayString(sub.materialName), 1),
                    _createElementVNode("div", _hoisted_28, _toDisplayString(sub.sumBox + '盒 | ' + sub.sumNum + sub.unitName), 1)
                  ]),
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("span", null, _toDisplayString(sub.procedureName ? sub.procedureName : '-') + " | " + _toDisplayString(sub.batch ? sub.batch : '-'), 1)
                  ])
                ]))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_30, [
      _createElementVNode("div", _hoisted_31, [
        _hoisted_32,
        _createElementVNode("span", null, _toDisplayString('本次备料生产工单 (' + orderCount(_unref(data).wtransferConfirmWorkOrderBeanList) +')'), 1)
      ])
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).wtransferConfirmWorkOrderBeanList, (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "order-item-style",
        key: index
      }, [
        _createElementVNode("div", _hoisted_33, _toDisplayString(item.workOrderNo), 1),
        _createElementVNode("div", _hoisted_34, _toDisplayString(item.typeDetail + '[' + item.planDate + ']'), 1),
        _createElementVNode("div", _hoisted_35, [
          _createElementVNode("div", _hoisted_36, [
            _hoisted_37,
            (item.batch)
              ? (_openBlock(), _createElementBlock("span", _hoisted_38, _toDisplayString(item.materialName + ' | ' + item.batch + ' | ' + item.procedureName + ' | ' + item.planNum + '' + item.unitName), 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_39, _toDisplayString(item.materialName + '|' + item.procedureName + ' | ' + item.planNum + '' + item.unitName), 1))
          ]),
          _createElementVNode("div", _hoisted_40, [
            _hoisted_41,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.workOrderUserList, (items, i) => {
              return (_openBlock(), _createElementBlock("span", {
                style: {"color":"#222"},
                key: i
              }, [
                _createTextVNode(_toDisplayString(items.proUserDepartName), 1),
                (item.workOrderUserList.length - 1 !== i)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _hoisted_42
                    ], 64))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ])
        ]),
        _hoisted_43
      ]))
    }), 128)),
    _hoisted_44,
    _createElementVNode("div", { class: "bottom-button" }, [
      _createElementVNode("button", {
        class: "button",
        onClick: submit
      }, "接收备料")
    ])
  ]))
}
}

})